const triggerRouterSignInCustomer = (sessionId,country, language, userData) => {
    const headersSignIn = new Headers();
    const countryUpperCase = country.toUpperCase();
    headersSignIn.append("x-wu-operationname", "signIn");
    headersSignIn.append("Content-Type", "application/json");
    headersSignIn.append("x-wu-accesscode", "RtYV3XDz9EA");
    headersSignIn.append("wucountrycode", countryUpperCase);
    headersSignIn.append("wulanguagecode", language);
    headersSignIn.append("x-wu-externalRefId", `webapp-a0fe9872-a28e-47f6-a4a4-1401859647a7`);
    headersSignIn.append("x-wu-correlationId", `webapp-8db2ca9e-5c99-400f-8a46-439e9600555a`);
    headersSignIn.append("x-wu-session-version", `3`);
    headersSignIn.append("version", `V2`);
    headersSignIn.append("x-wu-sessionId", sessionId);
    headersSignIn.append("x-wu-apiKey", `1978`);
    headersSignIn.append("accept-language", `en-CA`);
    const blackBoxString =  window.sessionStorage.getItem('blackBoxString')
  
    let SignInCustomerInput = {
          profile: {
            email: userData.emailId,
            credentials: {
              password: userData.password
            }
          },
          session: {
            captcha: {},
            channel: {
              type: "WEB",
              name: "Western Union",
              version: "9Z00",
              isResponsive: "true",
              deviceIdentifier: "RESPONSIVE_MOB"
            },
            security: {
              session: {
                id: sessionId
              },
              blackBoxData: {
                id: "101569194",
               ...(blackBoxString && {
                  data: blackBoxString
                }),
                length: blackBoxString?.length ? `${blackBoxString?.length.toString()}` : '0'
              }
            }
          }
    };
  
    const graphql = JSON.stringify({
      query: signInQuery,
      variables: {
        signInReq: SignInCustomerInput,
      },
    });
    const requestOptions = {
      method: "POST",
      headers: headersSignIn,
      body: graphql,
      redirect: "follow",
    };
  
    return fetchApiWu(routerUrl, requestOptions, "signIn")
      .catch((error) => console.log("triggerRouterSignCustomer Data not found: ", error));
  };
  
  